import React from 'react';
import Pages from './Pages.js';
// import BarLoader from 'react-spinners/ClipLoader';
// import { CSSRef } from '../components/CSSRef';

class Education extends Pages {
    componentDidMount() {
        window.scrollTo(0, 0)
        // setTimeout(function () {
        //     this.setState({ isLoading: false });
        // }.bind(this), 5000);
    }

  leftmenu = () => {
    return (

      <div className='leftmenu'>
        <div>Education</div>
        <br />
        <button onClick={() => this.scroll(this.firstRef)} className={'section'}> Overview </button>
        <button onClick={() => this.scroll(this.secondRef)} className={'section'}> Synthetic Biology Workshops Content Slides </button>
        <button onClick={() => this.scroll(this.thirdRef)} className={'section'}> Bioinformatics Workshops Content Slides</button>

      </div>
    )
  }
  righttext = () => {
    return (
      <div className='righttext'>
        <h2 ref={this.firstRef} >Overview</h2>
        <p>
          <br />
          We've realized that many secondary school pupils in Hong Kong don't have the chance to study synthetic biology and carry out relevant practical experiments. We aim to close this knowledge gap and ignite the curiosity of younger students in learning more about synthetic biology, by teaching them basic laboratory skills such as Gel Electrophoresis.
        </p><br />
        <h2 ref={this.secondRef} >Synthetic Biology Workshops Content Slides</h2>
        <p>
          <br />
          After hosting our Synthetic Biology Workshop, we realised that many secondary students in Hong Kong do not receive enough exposure to synthetic biology. HKU iGEM 2022 would like to ensure Synthetic Biology is accessible to all students form 4-6/year 11-year 13/ grade 10-grade12. The resources we developed effectively explain synthetic biology to a younger audience. By sharing the resources we hope to inspire more students to pursue a study in synthetic biology.
          <br /><br />
          <a href="https://static.igem.wiki/teams/4241/wiki/ihp/education/synbio-workshop-pptx.pdf" target="_blank" rel="noreferrer" >Click here to view the slides!</a><br /><br />
        </p> <br />
        <h2 ref={this.thirdRef} >Bioinformatics Workshops Content Slides</h2>
        <p>
          <br />
          After the workshop, we distributed our slides to all of our participants. Many of our students provided us with positive feedback on how useful our slides were, especially regarding learning new topics such as Python and Bioinformatics. Thus to inspire more students to develop an interest in the above mentioned topics, HKU iGEM 2022 would like to share our resources with the world. The resources we developed effectively explain Bioinformatics, and Python to audiences form 3/year 9/grade 8 and above.  We hope by sharing our resources, it could help educators and students around the world.
          <br /><br />
          <a href="https://static.igem.wiki/teams/4241/wiki/ihp/education/bioinf-day-1.pdf" target="_blank" rel="noreferrer" >Click here to view slides for Bioinformatics!</a><br /><br />
          <a href="https://static.igem.wiki/teams/4241/wiki/ihp/education/bioinfo-workshop-day-2.pdf" target="_blank" rel="noreferrer" >Click here to view slides for Python!</a>
        </p>


      </div>
    )
  }

  render() {
    return (
      <>
      {/* {this.state.isLoading ? <div className='load-container'><BarLoader color={'silver'} size={150} loading={this.state.isLoading} cssOverride={CSSRef} /></div> : null} */}
        <h1 className='des'>Education</h1>
        <div className='pageholder'>

          {this.leftmenu()}
          {this.righttext()}
        </div>
      </>
    )
  }
}


export default Education;
